// extracted by mini-css-extract-plugin
module.exports = {"Quiz":"Quiz_Quiz__3pPvu","QuizWrapper":"Quiz_QuizWrapper__181jt"};